import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { IconSpinner } from '../../../components';
import { getAllWineries, getPinedWineries } from '../../../services/winery';
import css from './YouMightAlsoLike.module.css';
import YouMightAlsoLikeCard from './YouMightAlsoLikeCard/YouMightAlsoLikeCard';

const YouMightAlsoLike = () => {
  const [wineries, setWineries] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() =>{
    getPinedWineries(3, setLoading, setWineries);
  }, []);

  return (
    <div className={css.youMightAlsoLikeWrapper}>
      <div className={css.youMightAlsoContainer}>
        <h1>You Might Also Like</h1>
        <div className={css.youMightAlso}>
          {loading ? (
            <div className={css.spinnerWrapper}>
              <IconSpinner />
            </div>
          ) : (
            <div className={css.youMightAlsoCardWrapper}>
              {wineries && wineries.slice().map((winery, index) => (
                <YouMightAlsoLikeCard key={index} winery={winery} />
              ))}
            </div>
          )}

        </div>
      </div>
    </div>
  )
}

export default YouMightAlsoLike
